import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import AuthService from 'cio/services/auth';
import DS from 'ember-data';
import FeaturesService from 'ember-feature-flags/services/features';
import ObjectTypesService from 'cio/services/object-types';
import ObjectTypeModel from 'cio/models/object-type';

export default class ObjectsRoute extends Route {
  @service auth!: AuthService;
  @service features!: FeaturesService;
  @service store!: DS.Store;
  @service objectTypes!: ObjectTypesService;

  crumb() {
    let objectType = this.modelFor(this.routeName) as ObjectTypeModel;
    return {
      name: objectType.name,
      path: this.routeName,
      model: objectType.slug,
    };
  }

  async model() {
    let { slug } = this.paramsFor('objects.type') as Record<string, string>;
    return this.objectTypes.getBySlug(slug);
  }

  redirect(model: ObjectTypeModel) {
    if (model == null) {
      this.router.transitionTo('objects');
      return;
    }
    let { slug } = this.paramsFor('objects.type') as Record<string, string>;
    // Since we use `slug` in URL only after v1 release, some might have "legacy" URL with `id`, thus we can try to match it.
    if (slug !== model.slug && slug === model.id) {
      // if that's the case, we need to replace old `slug` with actual `slug`
      this.router.replaceWith(this.routeName, model.slug);
    }
  }
}
